import { render, staticRenderFns } from "./ItemizedPaymentHistory.vue?vue&type=template&id=24f87dfc&scoped=true&"
import script from "./ItemizedPaymentHistory.vue?vue&type=script&lang=js&"
export * from "./ItemizedPaymentHistory.vue?vue&type=script&lang=js&"
import style0 from "./ItemizedPaymentHistory.vue?vue&type=style&index=0&id=24f87dfc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f87dfc",
  null
  
)

export default component.exports